import type { Modality } from '@/lib/contract';
import { modalityLabel } from '@/lib/format';
import { Badge } from '@/ui/badge';
import { cn } from '@/lib/cn';

/** EGO / RGB-D / AUDIO chips, as used in the vendor roster and capability matrix. */
export function ModalityChips({ modalities, className }: { modalities: Modality[]; className?: string }) {
  if (!modalities.length) return <span className="text-dim">—</span>;
  return (
    <span className={cn('inline-flex flex-wrap items-center gap-1', className)}>
      {modalities.map(modality => (
        <Badge key={modality}>{modalityLabel(modality)}</Badge>
      ))}
    </span>
  );
}
